var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 95.07",
    width: "50px",
    height: "50px",
    style: {
      enableBackground: "new 0 0 122.88 95.07"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0089D6;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.8,90.01l28.96-5.12l0.27-0.06L71.13,67.12c-4.94-5.83-10.17-11.99-14.79-17.83 c0-0.09,15.38-42.43,15.46-42.58C71.83,6.66,82.3,24.73,97.17,50.5l25.51,44.23l0.19,0.34l-47.33-0.01l-47.33-0.01l28.68-5.06 L56.8,90.01L56.8,90.01z M0,84.62c0-0.02,7.02-12.21,15.59-27.07l15.59-27.03l18.17-15.25C59.35,6.89,67.56,0.01,67.59,0 c-0.07,0.26-0.17,0.5-0.29,0.74L47.56,43.06L28.18,84.62l-14.09,0.02C6.34,84.66,0,84.64,0,84.62L0,84.62L0,84.62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureIcon);
export default __webpack_public_path__ + "static/media/azure-icon.2b83c7a3440214503ce4d3ed2a406aec.svg";
export { ForwardRef as ReactComponent };